<p>
  The setup of your device completed successfully. Click the button below to
  generate a verification code.
</p>
<br />
<div class="text-center">
  <button class="btn btn-primary" (click)="sendVerificationCode()">
    Send Code
  </button>
</div>
